var map = {
	"./chika.jpeg": "6FqY",
	"./ekwan.jpeg": "yLFy",
	"./eunike.jpeg": "mS3h",
	"./igede.jpeg": "gjmS",
	"./koentjoro.jpeg": "yQWD",
	"./nugraha.jpg": "8uuW",
	"./nurhayati.jpg": "3DA8",
	"./rudy.jpeg": "I3nk",
	"./therezia.jpeg": "9cEd",
	"./ukie.png": "C1JL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lcfm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial ^\.\/.*$
// module id = lcfm
// module chunks = 1